import { CaretRight, House } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export function Breadcrumbs({ items = [] }) {
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol>
        <li><Link to="/" aria-label="Home"><House aria-hidden="true" size={16} weight="fill" /></Link></li>
        {items.map((item, index) => (
          <li key={item.to || item.label}>
            <CaretRight aria-hidden="true" size={13} />
            {item.to && index < items.length - 1 ? <Link to={item.to}>{item.label}</Link> : <span aria-current={index === items.length - 1 ? 'page' : undefined}>{item.label}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}

